import styles from "./Prompts.module.css";
import Button from "../buttons/Button";
import FullscreenCard from "../containers/FullscreenCard";

const ConfirmPrompt = ({ showPrompt, text, confirmHandler, rejectHandler }) => {
  return (
    <>
      {showPrompt && (
        <FullscreenCard>
          <div className={styles.statusDivActive}>
            <p className={styles.confirmPromptText}>{text}</p>
            <div className={styles.confirmButtonDiv}>
              <Button text={"Yes"} disabled={false} onClick={confirmHandler} />
              <Button text={"No"} disabled={false} onClick={rejectHandler} />
            </div>
          </div>
        </FullscreenCard>
      )}
    </>
  );
};

export default ConfirmPrompt;
